import clsx from 'clsx';
import prettyMs from 'pretty-ms';
import format from 'date-fns/format';
import formatDistanceToNow from 'date-fns/formatDistanceToNow';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import ContentBox from 'components/CncUI/ContentBox';
import Typography from 'components/CncUI/Typography';
import Tooltip from 'components/CncUI/Tooltip';
import Format from 'utilities/format';

const useStyles = makeStyles(({ palette }) => ({
  root: {
    padding: '4px 16px',
  },
  content: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 8,
  },
  box: {
    width: 5,
    height: 34,
    cursor: 'pointer',
  },
  success: {
    background: palette.cncUI.alert.green.primary,
  },
  error: {
    background: palette.cncUI.alert.red.primary,
  },
}));

const CheckLogs = ({ name, logs }) => {
  const classes = useStyles();
  const success = clsx('logBox', classes.box, classes.success);
  const error = clsx('logBox', classes.box, classes.error);

  const formatDate = timestamp => {
    const date = new Date(parseInt(timestamp, 10));
    const distance = formatDistanceToNow(date, { includeSeconds: true });
    const formatted = format(date, 'MMMM do, yyyy @ p');
    return `${formatted} (${distance})`;
  };

  const logDate = timestamp =>
    format(new Date(parseInt(timestamp, 10)), 'MM/dd/yyyy p');

  return (
    <ContentBox className={classes.root}>
      <Grid container spacing={0}>
        <Grid item xs={12}>
          <Grid container spacing={0}>
            <Grid item xs={6}>
              <Typography variant="h6">{Format.humanize(name)}</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography variant="caption" size="short" align="right">
                {logDate(logs[logs.length - 1].date)} ~ {logDate(logs[0].date)}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <ContentBox shadow={false} dense className={classes.content}>
            {logs.reverse().map((log, i) => (
              <Tooltip
                key={`log_${i}`}
                size="medium"
                content={
                  <Grid container spacing={1}>
                    <Grid item xs={12}>
                      {formatDate(log.date)}
                    </Grid>
                    <Grid item xs={12}>
                      {log.message}
                    </Grid>
                    <Grid item xs={12}>
                      Completed in {prettyMs(log.time)}
                    </Grid>
                  </Grid>
                }
              >
                <div
                  key={`log_${i}`}
                  className={log?.status === 'UP' ? success : error}
                />
              </Tooltip>
            ))}
          </ContentBox>
        </Grid>
      </Grid>
    </ContentBox>
  );
};

export default CheckLogs;
